import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useStore } from 'src/stores';
import { toBillReadyCells, toBillReadyQueries } from './billReadyCell';

/**
 * The Bill ready cell for each row on the page (LB-6032), from property-service. Keyed on what is asked rather than on
 * the rows themselves, which are rebuilt on every render, and asked again whenever the list is read again: `listRead`
 * is the list as last read, which Refresh, the poll and the re-read after an allocation all replace. So a failed read
 * recovers, and an allocation that teaches the utility a new lag shows. Until this page's answer lands every row shows
 * a dash; a re-read that fails keeps the dates it had.
 */
export const useBillReadyDates = (rows, listRead) => {
  const store = useStore();
  const queries = toBillReadyQueries(rows);
  const queriesKey = queries.map(query => "".concat(query.key, "@").concat(query.serviceEnd)).join(',');
  const _useState = useState({
      key: '',
      answers: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    answered = _useState2[0],
    setAnswered = _useState2[1];
  useEffect(() => {
    if (!queries.length) return undefined;
    let current = true;
    store.companyBills.getBillReadyDatesAsync.run({
      bills: queries
    }).then(resp => {
      var _resp$response;
      // Nothing comes back from a failed or cancelled read. A page left before its answer came back must not paint
      // the next page's rows with it.
      if (current && resp) setAnswered({
        key: queriesKey,
        answers: (_resp$response = resp.response) !== null && _resp$response !== void 0 ? _resp$response : []
      });
    });
    return () => {
      current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queriesKey, listRead]);
  return toBillReadyCells(rows, answered.key === queriesKey ? answered.answers : []);
};